import { Col, Row } from 'antd';
import ReorderProcessCancel from 'components/ReorderProcess/ReorderProcessCancel';

import EditArticleOrderDate from './EditArticleOrderDate';

const StartProcessStepActions = ({ id, title, authors, orderDate, deliveryDate }) => {
  return (
    <Row gutter={24}>
      <Col
        xs={24}
        md={12}
      >
        <EditArticleOrderDate
          id={id}
          orderDate={orderDate}
          deliveryDate={deliveryDate}
          title={title}
          authors={authors.map((item) => item.author)}
        />
      </Col>
      <Col
        xs={24}
        md={12}
      >
        <ReorderProcessCancel
          offerID={id}
          committee="ou"
        />
      </Col>
    </Row>
  );
};

export default StartProcessStepActions;
